import React from 'react';
import ScrollMagie from '../../helpers/scrollmagie'

export default class detail extends React.Component {

    componentDidMount() {
        $("html, body").animate({scrollTop: 0}, 0);
        new ScrollMagie()
    }

    render() {
        return <section>
            <div className="row">
                <div className="gr-12 no-gutter relative">
                    <img src="public/images/lookbook/cover.jpg" alt="" style={{width: "100%"}}/>
                    <div className="lookbook" style={{position: "absolute", bottom: "29vw", right: 0, left: 0}}>
                        <h2>LOOKBOOK</h2>
                        <p>
                            Die neue Brillenkollektion "dabelju since 1966" von Wutscher Optik steht für Qualität,
                            modernes Brillendesign und Lebensfreude! Diese wurde in einem eigenen lebendigen Lookbook
                            inszeniert.
                            <br/> Sehen Sie selbst!
                        </p>
                    </div>
                </div>
            </div>

            <div style={{paddingTop: "10vw", paddingBottom: "10vw"}}>
                <div className="row">
                    <div className="gr-6">
                        <div className="image">
                            <img src="public/images/lookbook/collage_1_1.jpg" alt="" className="image-resp"/>
                        </div>
                    </div>
                    <div className="gr-3">
                        <div className="image" style={{
                            position: "relative",
                            zIndex: 0,
                            transform: "translate(10vw, 17vw)"
                        }}>
                            <img src="public/images/lookbook/collage_1_2.jpg" alt="" className="image-resp"/>
                        </div>
                        <div className="image" style={{
                            position: "relative",
                            zIndex: 0,
                            transform: "translate(20vw, 10vw)",
                            paddingBottom: "10vw"
                        }}>
                            <img src="public/images/lookbook/collage_1_3.jpg" alt="" className="image-resp"/>
                        </div>
                    </div>
                    <div className="gr-3">&nbsp;</div>
                </div>
            </div>

            <div style={{paddingTop: 0}}>
                <div className="row">
                    <div className="gr-3 relative">
                        <div className="image" style={{
                            position: "relative",
                            zIndex: 1,
                            transform: "translate(20vw, -10vw)"
                        }}>
                            <img src="public/images/lookbook/collage_2_1.jpg" alt="" className="image-resp"/>
                        </div>
                        <div className="image" style={{
                            position: "relative",
                            zIndex: 0,
                            transform: "translate(0vw, -15vw)",
                            paddingBottom: "0vw"
                        }}>
                            <img src="public/images/lookbook/collage_2_2.jpg" alt="" className="image-resp"/>
                        </div>
                        <div className="image" style={{
                            position: "relative",
                            zIndex: 0,
                            transform: "translate(20vw, -37vw)",
                            marginBottom: "-37vw"
                        }}>
                            <img src="public/images/lookbook/collage_2_3.jpg" alt="" className="image-resp"/>
                        </div>
                    </div>
                    <div className="gr-3">&nbsp;</div>
                    <div className="gr-6">
                        <div className="image">
                            <img src="public/images/lookbook/collage_2_4.jpg" alt="" className="image-resp"/>
                        </div>

                    </div>
                </div>
            </div>

            <div style={{paddingTop: 0}}>
                <div className="gr-4">
                    <div className="image" style={{
                        position: "relative",
                        zIndex: 0,
                        transform: "translate(0vw, -10vw)",
                        paddingBottom: "0vw"
                    }}>
                        <img src="public/images/lookbook/collage_3_1.jpg" alt="" className="image-resp"/>
                    </div>
                    <div className="image" style={{
                        position: "relative",
                        zIndex: 0,
                        transform: "translate(10vw, 0vw)",
                        paddingBottom: "0vw"
                    }}>
                        <img src="public/images/lookbook/collage_3_2.jpg" alt="" className="image-resp"/>
                    </div>
                </div>
                <div className="gr-2">&nbsp;</div>
                <div className="gr-4">
                    <div className="image" style={{
                        position: "relative",
                        zIndex: 0,
                        transform: "translate(7vw, 10vw)",
                        paddingBottom: "10vw",
                        width: "80%"
                    }}>
                        <img src="public/images/lookbook/collage_3_3.jpg" alt="" className="image-resp"/>
                    </div>
                </div>
                <div className="gr-2">&nbsp;</div>
            </div>

            <div>
                <div className="row">
                    <div className="gr-6">
                        <div className="image">
                            <img src="public/images/lookbook/collage_4_1.jpg" alt="" className="image-resp"/>
                        </div>
                    </div>
                    <div className="gr-3">
                        <div className="image" style={{
                            position: "relative",
                            zIndex: 0,
                            transform: "translate(10vw, 8vw)"
                        }}>
                            <img src="public/images/lookbook/collage_4_2.jpg" alt="" className="image-resp"/>
                        </div>
                        <div className="image" style={{
                            position: "relative",
                            zIndex: 0,
                            transform: "translate(20vw, 5vw)",
                            paddingBottom: "0vw"
                        }}>
                            <img src="public/images/lookbook/collage_4_3.jpg" alt="" className="image-resp"/>
                        </div>
                        <div className="image" style={{
                            position: "relative",
                            zIndex: 0,
                            transform: "translate(-10vw, 10vw)",
                            paddingBottom: "0vw"
                        }}>
                            <img src="public/images/lookbook/collage_4_4.jpg" alt="" className="image-resp"/>
                        </div>
                    </div>
                    <div className="gr-3">&nbsp;</div>
                </div>
            </div>

            <div style={{paddingTop: 0, paddingBottom: "12vw"}}>
                <div className="row">
                    <div className="gr-3 relative">
                        <div className="image" style={{
                            position: "relative",
                            zIndex: 1,
                            transform: "translate(0vw, -10vw)"
                        }}>
                            <img src="public/images/lookbook/collage_5_1.jpg" alt="" className="image-resp"/>
                        </div>
                        <div className="image" style={{
                            position: "absolute",
                            zIndex: 0,
                            transform: "scale(1.8)translate(5vw, 7vw)",
                            paddingBottom: "5vw"
                        }}>
                            <img src="public/images/lookbook/collage_5_2.jpg" alt="" className="image-resp"/>
                        </div>
                    </div>
                    <div className="gr-3">&nbsp;</div>
                    <div className="gr-6">
                        <div className="image">
                            <img src="public/images/lookbook/collage_5_3.jpg" alt="" className="image-resp"/>
                        </div>

                    </div>
                </div>
            </div>

            <div style={{paddingTop: 0, paddingBottom: "5vw"}}>
                <div className="row">
                    <div className="gr-2"></div>
                    <div className="gr-4">
                        <div className="image" style={{
                            position: "relative",
                            zIndex: 0,
                            transform: "translate(-6vw, 18vw)",
                            width: "63%"
                        }}>
                            <img src="public/images/lookbook/collage_6_1.jpg" alt="" className="image-resp"/>
                        </div>
                        <div className="image" style={{
                            position: "relative",
                            zIndex: 1,
                            transform: "translate(5vw, 8.5vw)",
                            paddingBottom: "5vw"
                        }}>
                            <img src="public/images/lookbook/collage_6_2.jpg" alt="" className="image-resp"/>
                        </div>
                    </div>
                    <div className="gr-1"></div>
                    <div className="gr-5">
                        <div className="image">
                            <img src="public/images/lookbook/collage_6_3.jpg" alt="" className="image-resp"/>
                        </div>
                    </div>
                </div>
            </div>


            <div className="fullscreen-image fixed"
                 style={{backgroundImage: "url(public/images/lookbook/footer.jpg)"}}></div>

            <div className="next animate">
                <div className="row">
                    <div className="gr-12">
                        <a href="#/about">
                            <h1>ABOUT</h1>
                        </a>
                    </div>
                </div>
            </div>
        </section>
    }
}



// WEBPACK FOOTER //
// ./src/scripts/pages/categories/lookbook.jsx